import { PipelineSettingsPage } from '@/pages/crm/settings/pipelines/PipelineSettingsPage';
import { createFileRoute } from '@tanstack/react-router';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/crm/settings/pipelines/$pipelineId')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['crmConfig.managePipelines'], redirectTo: '/dashboard' }),
	component: PipelineSettingsRoute,
});

function PipelineSettingsRoute() {
	const { pipelineId } = Route.useParams();
	return <PipelineSettingsPage pipelineId={pipelineId} />;
}
